// ** Initial State
const initialState = {
  dropdown: [],
  allData: [],
  data: [],
  total: 1,
  params: {},
  selectedBank: null
}

const banks = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ALL_BANKS_DROPDOWN':
      return { ...state, dropdown: action.data }
    case 'GET_ALL_BANKS':
      return { ...state, allData: action.data }
    case 'FILTER_ALL_BANKS':
      return {
        ...state,
        data: action.data,
        total: action.totalPages,
        params: action.params
      }
    case 'GET_BANK':
      return { ...state, selectedBank: action.selectedBank }
    case 'ADD_BANK':
      return { ...state }
    case 'DELETE_BANK':
      return { ...state }
    default:
      return { ...state }
  }
}
export default banks
